export default {
    mounted() {
        this.$emit("change:content-size", "fluid");
    },
    beforeDestroy() {
        this.$emit("reset:content-size");
    }
};
